import { API_endpoints } from "./config";

export const getParentKids = async (id?: number | null): Promise<any> => {
    try {
        const body = id ? { id } : {};

        const response = await fetch(API_endpoints.getParentsKids, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von Kinderdaten.");
        }
        const res=await response.json();

        return res
        
    } catch (error) {
        console.error("Fehler beim Laden von Kinderdaten:", error);
    }
};